<template>
  <div class="liveCategory">
    <Spin v-if="loading" fix></Spin>
    <Form
      v-else-if="category || isCreate"
      ref="formRef"
      :label-width="85"
      style="max-width: 600px"
      :model="formModel"
      :rules="rules"
    >
      <FormItem label="专题名称" prop="name">
        <Input
          v-model="formModel.name"
          placeholder="请输入专题名称"
          maxlength="50"
          show-word-limit
        />
      </FormItem>
      <FormItem label="专题简介" prop="description">
        <Input
          v-model="formModel.description"
          type="textarea"
          class="category__description__textarea"
          style="font-size: 12px"
          placeholder="请输入专题简介"
          :rows="4"
          maxlength="200"
          show-word-limit
        />
      </FormItem>
      <FormItem label="专题图片" :required="isCreate">
        <UploadPic
          ref="uploader"
          centerBox
          :action="uploadServer.uploadServerUrl"
          @save="onUploadSave"
          :imageUrl="formModel.imagePath"
          :fixedNumber="[16, 9]"
          :type="5"
          :resize="1"
        >
          <Button type="primary" icon="ios-cloud-upload-outline">
            {{ $t("Button.uploadImg") }}
          </Button>
        </UploadPic>
      </FormItem>
      <FormItem label=" ">
        <div class="form__buttons">
          <Button
            type="primary"
            v-if="isCreate"
            @click="create"
            :loading="saveOrCreateLoading"
          >
            创建
          </Button>
          <Button
            type="primary"
            v-else
            @click="save"
            :loading="saveOrCreateLoading"
          >
            保存
          </Button>
          <Button @click="back">返回</Button>
          <Button
            type="error"
            style="margin-left: auto"
            v-if="!isCreate"
            @click="del"
          >
            删除
          </Button>
        </div>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import api from "@/api/Api";
import UploadPic from "@/components/upload/upload-pic.vue";

export default {
  components: {
    UploadPic,
  },
  props: {
    id: {
      type: [String, Number],
      require: true,
    },
  },
  data() {
    return {
      loading: false,
      saveOrCreateLoading: false,
      formModel: {
        name: "",
        description: "",
        imagePath: "",
      },
      category: null,
    };
  },
  computed: {
    ...mapState({
      uploadServer: (state) => state.uploader.UploadServer,
      uploadPath: (state) => state.uploader.uploadPath,
    }),
    isCreate() {
      return +this.id === 0;
    },
    rules() {
      return {
        name: {
          required: true,
          message: "专题名称不能为空",
        },
        description: {
          required: true,
          message: "专题简介不能为空",
        },
      };
    },
  },
  methods: {
    async getCategory() {
      this.loading = true;
      try {
        const { data: info } = await api.call("liveRoomCategory/info", {
          id: +this.id,
        });
        this.category = info;
        Object.assign(this.formModel, {
          name: info.name,
          description: info.description,
          imagePath: info.imageUrl,
        });
      } catch (e) {
        console.error(e);
        // this.$Notice.error({
        //   title: "获取直播间专题详情失败",
        //   desc: e.resultMsg || e,
        // });
      }
      this.loading = false;
    },
    async save() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        this.saveOrCreateLoading = true;
        const params = {
          id: +this.id,
          name: this.formModel.name,
          description: this.formModel.description,
        };
        const promise = new Promise((resolve) => {
          this.$$uploadResolve = resolve;
        });
        if (this.$refs.uploader.file.id) {
          this.$refs.uploader.upload();
          await promise;
          Object.assign(params, {
            imagePath: this.uploadPath,
            uploadServerId: this.uploadServer.uploadServerId,
            uploadSoftwareId: this.uploadServer.softwareId,
          });
        } else if (this.uploadPath) {
          Object.assign(params, {
            imagePath: this.uploadPath,
            uploadServerId: this.uploadServer.uploadServerId,
            uploadSoftwareId: this.uploadServer.softwareId,
          });
        }
        try {
          await api.call("liveRoomCategory/save", params);
          if (window.history.state) {
            this.$router.back(-1);
          } else {
            this.$router.push(`/home/live_category/detail/${this.id}`);
          }
        } catch (e) {
          console.error(e);
          this.$Notice.error({
            title: "更新直播间专题失败",
            desc: e.resultMsg || e,
          });
        }
        this.saveOrCreateLoading = false;
      });
    },
    async create() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        this.saveOrCreateLoading = true;
        const params = {
          name: this.formModel.name,
          description: this.formModel.description,
        };
        const promise = new Promise((_resolve) => {
          this.$$uploadResolve = _resolve;
        });
        if (this.$refs.uploader.file.id) {
          this.$refs.uploader.upload();
          await promise;
          Object.assign(params, {
            imagePath: this.uploadPath,
            uploadServerId: this.uploadServer.uploadServerId,
            uploadSoftwareId: this.uploadServer.softwareId,
          });
        } else if (this.uploadPath) {
          Object.assign(params, {
            imagePath: this.uploadPath,
            uploadServerId: this.uploadServer.uploadServerId,
            uploadSoftwareId: this.uploadServer.softwareId,
          });
        } else {
          this.saveOrCreateLoading = false;
          this.$Notice.warning({
            title: "请选择专题图片",
          });
          return;
        }
        try {
          await api.call("liveRoomCategory/save", params);
          this.$router.push("/home/live_category/all");
        } catch (e) {
          console.error(e);
          this.$Notice.error({
            title: "创建直播间专题失败",
            desc: e.resultMsg || e,
          });
        }
        this.saveOrCreateLoading = false;
      });
    },
    async del() {
      this.$Modal.confirm({
        title: `确认删除`,
        content: `确认删除专题（${this.category.name}）?`,
        loading: true,
        onOk: async () => {
          try {
            await api.call("liveRoomCategory/delete", {
              id: +this.id,
            });
            this.$router.push("/home/live_category/all");
          } catch (e) {
            console.error(e);
            this.$Notice.error({
              title: this.$t("Message.remove.error"),
              desc: e.resultMsg,
            });
          }
          this.$Modal.remove();
        },
      });
    },
    async onUploadSave() {
      if (this.$$uploadResolve && typeof this.$$uploadResolve === "function") {
        this.$$uploadResolve();
        this.$$uploadResolve = null;
      } else {
        console.warn("没有检测到上传 promise");
      }
    },
    back() {
      if (window.history.state) {
        this.$router.back(-1);
      } else if (this.isCreate) {
        this.$router.push(`/home/live_category/all`);
      } else {
        this.$router.push(`/home/live_category/detail/${this.id}`);
      }
    },
  },
  mounted() {
    if (!this.isCreate) {
      this.getCategory();
    }
  },
};
</script>

<style lang="less" scoped>
.liveCategory {
  position: relative;
  padding: 20px;
  min-height: 200px;
  background-color: white;
  border-radius: 5px;

  .category__image {
    display: block;
    width: 200px;
    aspect-ratio: 16 / 9;
    margin-bottom: 15px;
  }

  .category__description__textarea {

    /deep/ textarea {
      font-size: 12px;
    }
  }

  .form__buttons {
    display: flex;
    gap: 10px;
  }
}
</style>
